import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-charity-invitation-sent',
    templateUrl: './charity-invitation-sent.component.html',
    styleUrls: ['./charity-invitation-sent.component.scss'],
    standalone: false
})
export class CharityInvitationSentComponent implements OnInit {

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService, public themeService: ThemeService) { }

  ngOnInit() {
  }

  goTo() {
    this.router.navigate(['/friend-invitation']);
  }

}
